<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Booking Records Reports</h1>
          <p>Choose Report from Booking Report list </p>
      </div>
  </div>
</section>


<div id="w3l-appointment">
<section class="appointment-section section-gap">
  <div class="wrapper">
      <div class="d-grid doctor-appointment">
          <div class="appointment-form">
              <form action="#" method="post">
                  <div class="fields-grid">
                    <div class="styled-input">
                      <!-- *************************** -->
<mat-chip-list >
  <a    (click)="openDialog_1()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'1.Reservation by doctor from date to date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_2()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'2.Reservation by room from date to date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_22()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'3.Reservation by visit type from date to date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_3()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'4.Reservation Over All from date to date' | translate }}</mat-chip></a>
</mat-chip-list>
<mat-chip-list >
  <a    (click)="openDialog_4()" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-file-text" style='color:rgb(255, 255, 255)'></i>  {{'5.Reservation by patient from date to date' | translate }}</mat-chip></a>
</mat-chip-list>

<mat-chip-list >
  <a    href="Home" style="text-align: center;"><mat-chip color="primary" style="cursor: grab;font-size: large;width: 600px;height: 50px; background-color: #7cbc44;color:rgb(255, 255, 255);text-align: center;"><i class="fa fa-home" style='color:rgb(255, 255, 255)'></i>  {{'Home' | translate }}</mat-chip></a>
</mat-chip-list>

</div>

                  </div>
              </form>
          </div>

          <div class="registerimg">
              <img src="assets/images/report2.jpg" alt="" />
          </div>
      </div>
      <div class="clear"> </div>
  </div>
</section>
</div>



